import PropTypes from 'prop-types';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import clsx from 'clsx';
import styles from './analysticsTrandIcon.module.scss';

const AnalyticsTrendIcon = ({ trend = 0 }) => {
    return (
        <div
            className={clsx(
                styles.root,
                trend > 0 && styles.positiveTrend,
                trend < 0 && styles.negativeTrend
            )}>
            {trend > 0 && <TrendingUpIcon />}
            {trend < 0 && <TrendingDownIcon />}
            {trend === 0 && <TrendingFlatIcon />}
        </div>
    );
};

AnalyticsTrendIcon.propTypes = {
    trend: PropTypes.number
};

export default AnalyticsTrendIcon;
